import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as GroupId } from '../../../../../../whole-house/canvas/group/Id';

export const Request = intersect(
	partial({
		id: GroupId,
		parentId: GroupId,
		layerIds: array(iotsUtils.UUID),
	})
)(
	struct({
		name: string,
	})
);
